import { render, staticRenderFns } from "./waschepacket.vue?vue&type=template&id=805bd91e&"
import script from "./waschepacket.vue?vue&type=script&lang=js&"
export * from "./waschepacket.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('805bd91e')) {
      api.createRecord('805bd91e', component.options)
    } else {
      api.reload('805bd91e', component.options)
    }
    module.hot.accept("./waschepacket.vue?vue&type=template&id=805bd91e&", function () {
      api.rerender('805bd91e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-8p97YwfJSlMY0/JS/comp/waschepacket.vue"
export default component.exports